import React, { Component } from "react";
import { Link } from "react-router-dom";
import smallLogo from "../images/logo-quantum-small.svg";
import $ from "jquery";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

class Header extends Component {
  state = {
    balance: undefined,
  };
  Header
  headerJquery = () => {
    const fixed_top = $("header");
    $(window).on("scroll", function () {
      if ($(this).scrollTop() > 300) {
        fixed_top.addClass("header-fixed fadeInUp");
      } else {
        fixed_top.removeClass("header-fixed fadeInUp");
      }
    });
  };
  

  componentDidMount() {
    this.headerJquery();
    // const balance = sdk.wallet.balance();
  }

  render() {
    return (
      
          <Navbar expand="lg" variant="dark" sticky="top">
          <Container >
            <div className="logo">
            
            <Link className="brand-logo" to="/">
                    <img src={smallLogo} alt="logo" width={100} height={100} />
                  </Link>
           
            </div>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="justify-content-end">
                <Nav.Link href="#home">Home</Nav.Link>
                <Nav.Link href="#roadmap">Roadmap</Nav.Link>
                <Nav.Link href="#tokenomics">Tokenomics</Nav.Link>
                <Nav.Link href="#faq">FAQs</Nav.Link>
                <Link className="nav-link" to="/arcade">Arcade</Link>
                <Link className="default-btn default-btn--small" to="/dashboard">Dashboard</Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
    );
  }
}

export default Header;
